/* home.js — Home page behaviors, ported verbatim from the full-site handoff
   pages/homepage/100X Equine Home.html (three inline scripts):
     1) video wall: stamp a muted-audio icon on each clip, duplicate each track for a seamless loop
     2) UGC wall lightbox: click a .gx-wall-tile to open a fullscreen figure, Esc/backdrop to close
     3) mobile sticky shop bar: reveal .m-shopbar once past the comparison section, hide over shop/footer
   The #mp-toggle dev preview + the JSX nav mount are intentionally NOT ported (global gutx-header owns the nav;
   dev tools dropped). Loaded deferred, so the DOM is parsed before these run. */

/* 1) Video wall: mute icon + seamless-loop duplication */
(function () {
  var muteSvg = '<span class="vw-mute" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 00-2.5-4v8a4.5 4.5 0 002.5-4zM19 5l-1.4 1.4A8 8 0 0119 12a8 8 0 01-1.4 5.6L19 19a10 10 0 000-14z"/></svg></span>';
  document.querySelectorAll('.vw-card').forEach(function (c) { c.insertAdjacentHTML('beforeend', muteSvg); });
  document.querySelectorAll('.vw-track').forEach(function (t) { t.innerHTML += t.innerHTML; });
})();

/* 2) UGC wall lightbox */
(function () {
  var lb = null;
  function close() { if (lb) { lb.remove(); lb = null; } }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.gx-wall-tile') : null;
    if (t) {
      var src = t.getAttribute('data-src'), cap = t.getAttribute('data-cap') || '';
      close();
      lb = document.createElement('div');
      lb.className = 'gx-wall-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      var fig = document.createElement('figure');
      fig.className = 'gx-wall-lb-fig';
      var img = document.createElement('img'); img.src = src; img.alt = cap;
      var cc = document.createElement('figcaption'); cc.textContent = cap;
      fig.appendChild(img); fig.appendChild(cc);
      var x = document.createElement('button'); x.className = 'gx-wall-lb-x'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
      lb.appendChild(x); lb.appendChild(fig);
      fig.addEventListener('click', function (ev) { ev.stopPropagation(); });
      lb.addEventListener('click', close);
      document.body.appendChild(lb);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* 3) Mobile sticky shop bar */
(function () {
  var bar = document.querySelector('.m-shopbar');
  var trigger = document.querySelector('.gx-section.dark');   // the comparison section
  var shop = document.querySelector('#subscribe');            // build-a-bundle
  var foot = document.querySelector('.gx-foot');
  if (!bar || !trigger) return;
  var armed = false;   // becomes true once they've reached the comparison section
  function update() {
    var vh = window.innerHeight;
    // Arm once the comparison section has scrolled up into the middle of the viewport.
    if (!armed && trigger.getBoundingClientRect().top < vh * 0.6) armed = true;
    // Hide zones: the shop module or the footer are on screen (no need to nag).
    var inShop = shop ? shop.getBoundingClientRect().top < vh - 40 : false;
    var inFoot = foot ? foot.getBoundingClientRect().top < vh - 20 : false;
    bar.setAttribute('data-show', (armed && !inShop && !inFoot) ? 'true' : 'false');
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
